'use client';

import { useEffect } from 'react';

export function ScheduledPostsChecker() {
  useEffect(() => {
    const checkScheduledPosts = async () => {
      try {
        // Add a small random delay to prevent all users checking at exactly the same time
        const randomDelay = Math.floor(Math.random() * 2000);
        await new Promise(resolve => setTimeout(resolve, randomDelay));
        
        // Check if we've checked recently (within the last 10 minutes)
        const lastCheck = localStorage.getItem('lastScheduledPostsCheck');
        const now = Date.now();
        
        if (lastCheck && now - parseInt(lastCheck) < 10 * 60 * 1000) {
          // Skip check if we checked recently
          return;
        }
        
        // Update the last check time
        localStorage.setItem('lastScheduledPostsCheck', now.toString());
        
        // Call the API endpoint to check and publish scheduled posts
        const response = await fetch('/api/check-scheduled-posts', {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache',
          },
        });
        
        const data = await response.json();
        
        // Log the result (only in development)
        if (process.env.NODE_ENV === 'development') {
          console.log('Scheduled posts check:', data);
        }
      } catch (error) {
        // Silent fail - we don't want to disrupt the user experience
        console.error('Error checking scheduled posts:', error);
      }
    };

    // Check when the component mounts
    checkScheduledPosts();
    
    // No need to return a cleanup function
  }, []);

  // This component doesn't render anything
  return null;
}